// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"267663cd","480":"79ff58f1","838":"91e62204"}[chunkId] + ".js";
};